export const RESIZABLE_SIDEBAR_MIN_WIDTH = 520 as const;
export const SIDEBAR_MAX_WIDTH_RATIO = 0.5 as const;
export const DEFAULT_SIDEBAR_MAX_WIDTH = 700 as const;
